import { render, staticRenderFns } from "./GiftHandoverGate.vue?vue&type=template&id=1527ba31&"
import script from "./GiftHandoverGate.vue?vue&type=script&lang=js&"
export * from "./GiftHandoverGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports